import React from 'react'
import { Route, Routes } from 'react-router'
import SystemMasterListPage from '../app/master/pages/SystemMasterListPage'
import UserListPage from '../app/admin/user/pages/UserListPage'
import UserDetailsPage from '../app/admin/user/pages/UserDetailsPage'
import UserRoleListPage from '../app/admin/user/pages/UserRoleListPage'
import AdminLandingPage from '../app/admin/dashboard/pages/AdminLandingPage'

function AdminRoutes() {
  return (
    <>
      <Routes>
        {/* Business Details */}
        <Route path="/" element={<AdminLandingPage/>}></Route>
        {/* User */}
        <Route path="/user/list" element={<UserListPage /> }></Route>
        <Route path="/user/details/:id" element={<UserDetailsPage /> }></Route>
        <Route path="/user/role" element={<UserRoleListPage /> }></Route>
        <Route path="/master/list" element={ <SystemMasterListPage /> } />
      </Routes>
    </>
  )
}

export default AdminRoutes